<template>
      <div id="map" class="rounded-2"></div>
</template>

<script setup>
import { onMounted, defineProps, watch, ref } from "vue";

const props = defineProps(["coordinates"]);
const map = ref(null);
const marker = ref(null);

onMounted(() => {
if (props.coordinates && props.coordinates.length == 2) {
      initializeMap(props.coordinates);
}
});
watch(() => props.coordinates, (newCoordinates) => {
if (map.value && newCoordinates && newCoordinates.length == 2) {
      updateMarker(newCoordinates);
}
}, { immediate: true }); 

function initializeMap(coordinates) {
map.value = new nmp_mapboxgl.Map({
      mapType: "neshanRaster",
      container: "map",
      zoom: 13,
      pitch: 0,
      center: [coordinates[1], coordinates[0]], 
      trackResize: true,
      interactive: false,
      touchZoomRotate: { around: "center" },
      scrollZoom: { around: "center" },
      mapKey: "web.0f8e46e0aba84f5fbdcf09ae6b11532d",
      poi: false,
      traffic: false,
      mapTypeControllerStatus: { show: false, position: "top-left" }
});

// Add marker
const supplierMarker = document.createElement("div");
supplierMarker.className = "shop-info";

marker.value = new nmp_mapboxgl.Marker(supplierMarker)
      .setLngLat([coordinates[1], coordinates[0]])
      .addTo(map.value);
}

function updateMarker(coordinates) {
if (marker.value) {
      marker.value.setLngLat([coordinates[1], coordinates[0]]);
      map.value.setCenter([coordinates[1], coordinates[0]]);
}
}
</script>

<style>
.shop-info {
background-image: url('../../../../assets/img/shop.png');
background-size: cover;
width: 32px;
height: 40px;
top: -20px;
cursor: pointer;
}
</style>
